import { Injectable, OnDestroy, inject } from '@angular/core';
import { PrivilegesService } from '@app/privileges';
import { interval, Observable } from 'rxjs';
import { Subscription } from 'rxjs';
import { distinctUntilChanged, filter, startWith, switchMap, tap } from 'rxjs/operators';
import { SyncFacade } from '@app/store/products-sync';

@Injectable()
export class ProductsSyncService implements OnDestroy {
    private syncFacade = inject(SyncFacade);
    private privilegesService = inject(PrivilegesService);

    firstRun = true;
    timer$ = interval(4000);
    syncing$: Observable<boolean>;

    private subscriptions$ = new Subscription();
    private watchSyncSubscriptions$: Subscription;

    ngOnDestroy(): void {
        if (this.subscriptions$) {
            this.subscriptions$.unsubscribe();
        }
        if (this.watchSyncSubscriptions$) {
            this.watchSyncSubscriptions$.unsubscribe();
        }
    }

    init(): void {
        this.subscriptions$ = new Subscription();
        this.syncing$ = this.syncFacade.selectSyncing$();
        this.subscriptions$.add(
            this.syncing$
                .pipe(
                    filter(() => this.privilegesService.hasPermission('ROLE_FEATURE_PRODUCT_SYNC')),
                    distinctUntilChanged(),
                    tap((value) => {
                        if (value) {
                            this.start();
                        } else {
                            this.stop();
                        }
                    }),
                )
                .subscribe(),
        );
    }

    private start(): void {
        this.watchSyncSubscriptions$ = this.timer$
            .pipe(
                startWith(true),
                switchMap(() => {
                    return this.syncFacade.selectSyncing$();
                }),
                filter((value) => value),
                tap(() => {
                    this.syncFacade.checkSyncing(this.firstRun);
                    if (this.firstRun) {
                        this.firstRun = false;
                    }
                }),
            )
            .subscribe();
    }

    private stop(): void {
        if (this.watchSyncSubscriptions$) {
            this.watchSyncSubscriptions$.unsubscribe();
        }
    }
}
